import { render, staticRenderFns } from "./ManageCompaniesDetailsView.vue?vue&type=template&id=7a2e0dc3&"
import script from "./ManageCompaniesDetailsView.vue?vue&type=script&lang=ts&"
export * from "./ManageCompaniesDetailsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports